export const FORM_SIGNIN = 'signin';
// export const FORM_SIGNUP = 'signup';
export const FORM_FORGOT = 'forgot';
export const FORM_RESET_PASSWORD = 'resetPassword';
